import React from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';
import { Create, SimpleForm } from 'react-admin';
import AchievementFormFields from './AchievementFormFields';
import {
  AchievementType,
  TriggerType,
  isProtectedAchievementName,
  PROTECTED_ACHIEVEMENT_NAMES,
} from './achievementConstants';

const isForumOrProfile = (type) =>
  Number(type) === AchievementType.Forum || Number(type) === AchievementType.Profile;

const validateAchievement = (values) => {
  const errors = {};

  if (isProtectedAchievementName(values.name)) {
    errors.name =
      'This achievement name is reserved for backend-managed badges. Please choose a new title.';
  }

  if (Number(values.triggerType) === TriggerType.Coded && isForumOrProfile(values.type)) {
    errors.type =
      'Forum and Profile achievements are provisioned in code. Switch to a Times trigger or contact Engineering.';
  }

  return errors;
};

const AchievementCreate = (props) => (
  <Create {...props}>
    <SimpleForm validate={validateAchievement}>
      <Card style={{ maxWidth: 720, width: '100%', margin: '0 auto' }}>
        <CardContent>
          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            style={{ marginBottom: 16 }}
          >
            The following achievement names are managed in code:{' '}
            {PROTECTED_ACHIEVEMENT_NAMES.join(', ')}. Use descriptive variants for new badges
            instead of reusing these names.
          </Typography>
          <AchievementFormFields />
        </CardContent>
      </Card>
    </SimpleForm>
  </Create>
);

export default AchievementCreate;
